import { Common } from '@stockbit/ui';
import Image from 'global/Image';
import { Item, Description } from '../styled';
import { BenefitsContainer } from './styled';
import benefits from './constants';

const { Text } = Common;

const MulaiInvestasiBenefits = () => (
  <BenefitsContainer>
    {benefits.map((b) => (
      <Item key={b.title} className="benefit__sized">
        <Image src={b.image} />
        <Text size="30px" family="bold" as="h2">
          {b.title}
        </Text>
        <Description
          size="17px"
          dangerouslySetInnerHTML={{
            __html: b.desc,
          }}
        />
      </Item>
    ))}
  </BenefitsContainer>
);

export default MulaiInvestasiBenefits;
